module.exports = __webpack_public_path__ + "static/media/agentur_reference_logos_02_mobile.2e8a1b44.png";